import React from 'react';
import Header from '../../components/Header';
import BetTicker from '../../components/BetTicker';

class BetTickerSinglePage extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {layoutProp: decodeURIComponent(window.location.search.substring(1).split('=')[1])};
    }

    render() {
        return (
            <div className="content bet-ticker-page">
                <Header />
                <BetTicker { ...this.state }/>
            </div>
        );
    }
}

export default BetTickerSinglePage;
